import UseOfProceeds from './UseOfProceeds';

export default UseOfProceeds;
